import React from "react"
import { useLang } from "hooks/useLang"
import Image from "next/image"

const MaintenanceScreen = () => {
    const { t } = useLang()

    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-white dark:bg-primary-theme-500">
            <div className="flex flex-col items-center justify-center gap-8 p-8 text-center">
                <div className="relative h-[200px] w-full md:h-[300px]">
                    <Image
                        src="/svg/serverError.svg"
                        alt="maintenance"
                        fill
                        priority
                    />
                </div>
                <h1 className="text-2xl font-bold text-primary-theme-400 dark:text-white md:text-4xl">
                    {t("maintenance_title") || "Site Maintenance"}
                </h1>
                <p className="text-base text-gray-600 dark:text-gray-300 md:text-lg">
                    {t("maintenance_message") ||
                        "We're currently performing maintenance. Please check back soon."}
                </p>
            </div>
        </div>
    )
}

export default MaintenanceScreen
